import { createReducer, on } from '@ngrx/store';
import {
	clearUSignalErrorAction,
	loadAdminRootSuccessAction,
	loadUSignaleSuccessAction,
	saveUsignalErrorAction,
} from './admin.actions';
import { AdminRootResource, UnprocessableEntityError, UnterscheidungssignalListResource } from './admin.model';
import { createEmptyStateResource, createStateResource, StateResource } from '@schir-int-client/ngrx-helpers';
import { routerNavigatedAction } from '@ngrx/router-store';

export interface AdminState {
	admin: AdminRootResource | null;
	unterscheidungssignale: StateResource<UnterscheidungssignalListResource>;
	usignalError: UnprocessableEntityError;
}

export const initialState: AdminState = {
	admin: null,
	unterscheidungssignale: createEmptyStateResource(),
	usignalError: null,
};

export const adminReducer = createReducer(
	initialState,
	on(loadAdminRootSuccessAction, (state: AdminState, { adminRoot }): AdminState => ({
		...state,
		admin: adminRoot,
	})),
	on(loadUSignaleSuccessAction, (state: AdminState, { uSignale }): AdminState => ({
		...state,
		unterscheidungssignale: createStateResource(uSignale),
	})),
	on(saveUsignalErrorAction, (state: AdminState, { error }): AdminState => ({
		...state,
		usignalError: sortIssues(error),
	})),
	on(clearUSignalErrorAction, (state: AdminState): AdminState => ({
		...state,
		usignalError: null,
	})),
	on(routerNavigatedAction, (state: AdminState): AdminState => ({
		...state,
		unterscheidungssignale: {
			...state.unterscheidungssignale,
			reload: true,
		},
	}))
);

function sortIssues(error: UnprocessableEntityError) {
	error.error.issues.sort((a, b) => a.field.localeCompare(b.field));
	return error;
}
